import { Card } from "primereact/card";
import { BsFlagFill } from "react-icons/bs";
import React, { useEffect, useState, forwardRef, useImperativeHandle, useRef } from 'react'
import { setindex30s } from "store/perFormExam/perFormExam";
import PropTypes from 'prop-types';
// import './exam.scss';
import { useSelector, useDispatch } from 'react-redux';
import { setTextCountDown, settime5s } from "store/perFormExam/perFormExam";
const ClockInner = forwardRef((props, _ref) => {
  let { onChange, onTimeout } = props;
  const [count, setCount] = useState(props.time || 0);
  const dispatch = useDispatch();
  const hasTimedOut = useRef(false);
  // Chỉ cho phép timeout khi đã nhận được thời gian hợp lệ > 0
  // Tránh false timeout khi chuyển dạng bài (countDown trong localStorage = 0 từ bài trước)
  const hasStarted = useRef(props.time > 0);
  // Luôn giữ reference mới nhất của onTimeout, tránh stale closure
  const onTimeoutRef = useRef(onTimeout);
  useEffect(() => { onTimeoutRef.current = onTimeout; });

  useEffect(() => {
    if (props.time !== undefined && props.time !== null) {
      setCount(props.time);
      // Khi nhận thời gian mới > 0 (chuyển dạng bài), reset timeout flag
      if (props.time > 0) {
        hasTimedOut.current = false;
        hasStarted.current = true;
      }
    }
  }, [props.time]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((data) => {
        if (data <= 0) return data; // Không đếm xuống dưới 0
        let newCount = data - 1;
        onChange(newCount);
        localStorage.setItem('countDown', newCount);
        return newCount;
      })
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  // Xử lý hết giờ qua useEffect (đúng cách React), không gọi trong render
  // hasStarted: chỉ timeout khi đã nhận thời gian hợp lệ, tránh false timeout khi mount với time=0
  useEffect(() => {
    if (count <= 0 && !hasTimedOut.current && hasStarted.current) {
      hasTimedOut.current = true;
      dispatch(setTextCountDown('HẾT GIỜ'));
      if (typeof onTimeoutRef.current === 'function') {
        onTimeoutRef.current();
      } else {
        window.location.href = 'examdetail';
      }
    }
  }, [count]);

  useImperativeHandle(_ref, () => ({
    getTimeCountDown: () => {
      return count;
    }
  }));

  function format(time) {
    let hours = Math.floor(time / 3600);
    let minutes = Math.floor((time % 3600) / 60);
    let seconds = time % 60;
    hours = hours.toString().padStart(2, '0');
    minutes = minutes.toString().padStart(2, '0');
    seconds = seconds.toString().padStart(2, '0');

    if (time > 0) {
      const formattedTime = `${hours}:  ${minutes}: ${seconds}`;
      dispatch(setTextCountDown(formattedTime));
      return formattedTime;
    }
    return 'HẾT GIỜ';
  }

  return (
    <div className="displayedTime" style={{ marginRight: '0.5em' }}
    >
      <div style={{ color: count < 30 ? 'red' : 'black', fontSize: '20px', fontWeight: '700' }}>{format(count)}</div>
      <div style={{ fontSize: '14px' }}>Time remaining</div>
    </div>
  )
})

const CountDown = (props) => {
  const { time } = props
  const [datatimes, setdatatimes] = useState(parseInt(time))
  function startTimer(times) {
    let seconds = times % 60;
    let minutes = Math.floor(times / 60);
    minutes = minutes.toString().length === 1 ? "0" + minutes : minutes;
    seconds = seconds.toString().length === 1 ? "0" + seconds : seconds;
    setInterval(() => {
      const newCount = times - 1;
      setdatatimes(newCount)
    }, 1000);
    return minutes + ':' + seconds;
  }

  useEffect(() => {
    startTimer(datatimes);
  }, [time])
  return (
    <>
      <span className="text-time">{startTimer(datatimes)}</span>
    </>
  )
}
ClockInner.propTypes = {
  onChange: PropTypes.func,
  onTimeout: PropTypes.func,
};
ClockInner.defaultProps = {
  onChange: () => { },
  onTimeout: null,
}
const Clock = React.memo(ClockInner);
export { Clock, CountDown }
